import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../core/firebase/firebase';
import { useAuth } from '../core/firebase/useAuth';
import { IconSettings, IconBell, IconUser } from './Icons';
import { useLang } from '../core/i18n';

export default function TopBar() {
  const navigate     = useNavigate();
  const { dir }      = useLang();
  const { user }     = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user) { setUnread(0); return; }

    const unsubs = [];
    const counts = [0, 0];
    const update = () => setUnread(counts[0] + counts[1]);

    try {
      const q1 = query(collection(db, 'notifications'), where('receiverId', '==', user.uid), where('read', '==', false));
      unsubs.push(onSnapshot(q1, s => { counts[0] = s.size; update(); }, () => {}));

      const q2 = query(collection(db, 'notifications'), where('userId', '==', user.uid), where('read', '==', false));
      unsubs.push(onSnapshot(q2, s => { counts[1] = s.size; update(); }, () => {}));
    } catch {}

    return () => unsubs.forEach(u => u());
  }, [user]);

  return (
    <div style={{ 
      ...styles.bar, 
      direction: dir,
      background: 'var(--bg-primary)',
      borderBottom: '1px solid var(--border-color)',
      boxShadow: 'var(--shadow-sm)',
    }}>
      <button className="icon-btn" style={{...styles.iconBtn, color: 'var(--text-secondary)'}} onClick={() => navigate('/settings')}>
        <IconSettings size={20} color="currentColor" />
      </button>

      <div style={styles.logo} onClick={() => navigate('/')}>
        <div style={{...styles.logoMark, background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'}}>
          <img src="/og-image.png" alt="NexSap" style={styles.logoImg} />
        </div>
        <span style={{...styles.logoText, background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>NexSap ✨</span>
      </div>

      <div style={styles.right}>
        <button className="icon-btn" style={{...styles.iconBtn, color: 'var(--text-secondary)'}} onClick={() => navigate('/notifications')}>
          <div style={{ position: 'relative' }}>
            <IconBell size={20} color="currentColor" />
            {unread > 0 && (
              <span style={styles.badge}>{unread > 9 ? '9+' : unread}</span>
            )}
          </div>
        </button>
        <button className="icon-btn" style={styles.iconBtn} onClick={() => navigate('/profile')}>
          <IconUser size={18} color="#65676B" />
        </button>
      </div>
    </div>
  );
}

const styles = {
  bar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 16px',
    background: '#FFFFFF',
    borderBottom: '1px solid #E4E6EA',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
  },
  logoMark: {
    width: 32,
    height: 32,
    borderRadius: 10,
    overflow: 'hidden',
    background: 'linear-gradient(135deg, #1877F2, #0a5fd1)',
    padding: 2,
    flexShrink: 0,
  },
  logoImg: {
    width: '100%',
    height: '100%',
    borderRadius: 8,
    objectFit: 'cover',
  },
  logoText: {
    color: '#1877F2',
    fontWeight: 800,
    fontSize: 19,
    letterSpacing: '-0.3px',
  },
  right: { display: 'flex', gap: 6 },
  iconBtn: {
    background: '#F0F2F5',
    border: '1px solid #E4E6EA',
    borderRadius: 22,
    width: 38,
    height: 38,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  badge: {
    position: 'absolute',
    top: -7,
    right: -8,
    background: '#FA3E3E',
    color: '#fff',
    fontSize: 9,
    fontWeight: 800,
    borderRadius: 99,
    padding: '2px 4px',
    minWidth: 15,
    textAlign: 'center',
    lineHeight: '12px',
    boxShadow: '0 2px 6px rgba(250,62,62,0.35)',
  },
};
